import { useEffect, useState } from "react";

/**
 * Returns `value` delayed by `delay` ms, resetting the timer on every change.
 * Used by the header search bar so typing a chassis number issues one request
 * instead of one per keystroke.
 */
export default function useDebouncedValue(value, delay = 250) {
    const [debounced, setDebounced] = useState(value);

    useEffect(() => {
        const id = setTimeout(() => setDebounced(value), delay);
        return () => clearTimeout(id);
    }, [value, delay]);

    return debounced;
}
